import {
  GET_WIDGETS_BY_PAGE_ID,
  GET_WIDGETS_BY_PAGE_ID_SUCCESS,
  CREATE_WIDGET,
  DUPLICATE_WIDGET_TO_ANOTHER_PAGE,
} from './constants'

export function getWidgetsByPageIdAction(payload) {
  return {
    type: GET_WIDGETS_BY_PAGE_ID,
    payload,
  }
}

export function getWidgetsByPageIdSuccess(payload) {
  return {
    type: GET_WIDGETS_BY_PAGE_ID_SUCCESS,
    payload,
  }
}

export function createWidgetAction(payload) {
  return {
    type: CREATE_WIDGET,
    payload,
  }
}

export function duplicateWidgetAnotherPageAction(payload){
  return {
    type: DUPLICATE_WIDGET_TO_ANOTHER_PAGE,
    payload,
  }
}